// extracted by mini-css-extract-plugin
export default {"permissions":"styles_permissions__77PHP","item":"styles_item__dbtzz","itemPlain":"styles_itemPlain__LG1gX","select":"styles_select__RUS2Z"};